import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { stylesShareSite } from "../../shareSiteStylesMui/ShareSiteStylesMuiComponents";
import { ListOfSpeciesData } from "../../../../../redux/slices/shareSite/shareSiteTypes";

type ShareSiteSpeciesFilterParams = {
  setSelectSpecieFilter: (value: number) => void;
  selectedSpecie: number;
  listOfSpeciesFilter: ListOfSpeciesData[];
  listOfSpeciesLoading: boolean;
  storagesLoading: boolean;
  storageSharingLoading: boolean;
  storageSharedDeleteLoading: boolean;
};

const ShareSiteSpeciesFilter: FC<ShareSiteSpeciesFilterParams> = ({
  setSelectSpecieFilter,
  selectedSpecie,
  listOfSpeciesFilter,
  listOfSpeciesLoading,
  storagesLoading,
  storageSharedDeleteLoading,
  storageSharingLoading,
}) => {
  const [t] = useTranslation("global");
  return (
    <Box>
      <FormControl
        disabled={listOfSpeciesLoading}
        sx={stylesShareSite.filterInputs}
        fullWidth
      >
        <InputLabel id="demo-simple-select-label">
          {t("Common_options.select")}
        </InputLabel>
        <Select
          disabled={
            listOfSpeciesLoading ||
            storagesLoading ||
            storageSharedDeleteLoading ||
            storageSharingLoading
          }
          value={selectedSpecie}
          label={t("Common_options.select")}
          onChange={(e) => setSelectSpecieFilter(e.target.value as any)}
        >
          {listOfSpeciesFilter.map((values) => (
            <MenuItem key={values.id} value={values.id}>
              {values.textId.text}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default ShareSiteSpeciesFilter;
